// extracted by mini-css-extract-plugin
export default {"container":"kL-z","topReviewHeading":"lL-z","criticalReview":"mL-z","favorableReview":"nL-z","vsSeparator":"oL-z"};